import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toHandlers as _toHandlers } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "input-group-text"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["value", "type", "required", "maxlength"];
const _hoisted_4 = {
  key: 1,
  style: {
    "padding-left": "0.5rem"
  }
};
const _hoisted_5 = {
  key: 1,
  class: "input-group-text"
};
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback",
  style: {
    "display": "block"
  }
};
const _hoisted_7 = {
  key: 0,
  class: "valid-feedback"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': $props.isFormGroup,
      'd-inline-block': $props.isInlineBlock
    })
  }, [_renderSlot(_ctx.$slots, "label", {}, () => [$props.label ? (_openBlock(), _createElementBlock("label", {
    key: 0,
    class: _normalizeClass($props.labelClasses)
  }, _toDisplayString($props.label), 3)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "span", {}, () => [$props.span ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass($props.labelClasses),
    style: {
      "font-size": "0.75rem"
    }
  }, _toDisplayString($props.span), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: _normalizeClass([{
      'input-group': $options.hasIcon
    }, {
      focused: $data.focused
    }, {
      'input-group-alternative': $props.alternative
    }, {
      'has-label': $props.label || _ctx.$slots.label
    }, {
      'is-invalid': !$props.valid
    }, {
      'form-inline': $props.isFormInline
    }, $props.inputGroupClasses])
  }, [$props.prependIcon || _ctx.$slots.prepend ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createElementVNode("i", {
    class: _normalizeClass($props.prependIcon)
  }, null, 2)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", _mergeProps($options.slotData, {
    valid: $props.valid
  }), () => [$props.inlineHeadText ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.inlineHeadText), 1)) : _createCommentVNode("", true), _createElementVNode("input", _mergeProps({
    value: $props.modelValue,
    type: $props.type
  }, _ctx.$attrs, {
    required: $props.required,
    class: ["form-control", [{
      'is-invalid': !$props.valid
    }, $props.inputClasses]],
    maxlength: $props.maxLength
  }, _toHandlers($options.listeners, true)), null, 16, _hoisted_3), $props.inlineTailText ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.inlineTailText), 1)) : _createCommentVNode("", true)]), $props.appendIcon || _ctx.$slots.append ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createElementVNode("i", {
    class: _normalizeClass($props.appendIcon)
  }, null, 2)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "infoBlock"), _renderSlot(_ctx.$slots, "error", {}, () => [$props.inValidMessage && !$props.valid ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($props.inValidMessage), 1)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "success", {}, () => [!$props.inValidMessage && $props.valid ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($props.successMessage), 1)) : _createCommentVNode("", true)])], 2)], 2);
}